import Axios from "./axios";

const endpoint = "/api/construction";

export default {
  //현장등록
  //constructionName[필수],completion[필수],constructionAddress,orderManagerId,constructionManagerId,invoiceManagerId
  //{"completion": "string","constructionAddress": "string","constructionId": 0,"constructionManagerId": 0,
  //"constructionName": "string","invoiceManagerId": 0,"orderManagerId": 0}
  constructionCreate: (data) => Axios.post(`${endpoint}/create`, data),

  //현장삭제
  //constructionId
  //{"constructionId": 0}
  constructionDelete: (data) => Axios.post(`${endpoint}/Delete`, data),

  //현장 조건별 조회
  //{"completion": "string","constructionAdminName": "string","constructionAdminPhoneNumber": "string",
  //"constructionName": "string","phoneNumber": "string"}
  constructionFilter: (data) => Axios.post(`${endpoint}/filter-list`, data),

  //현장 조회(단일)
  //{"constructionId": 0}
  constructionInformation: (data) =>
    Axios.post(`${endpoint}/information`, data),

  //현장목록조회(특정 유저)
  //{"userId": 0}
  constructionListOnUser: (data) =>
    Axios.post(`${endpoint}/list-on-user`, data),

  //현장정보수정
  //{"completion": "string","constructionAddress": "string","constructionId": 0,
  //"constructionManagerId": 0,"constructionName": "string","invoiceManagerId": 0,"orderManagerId": 0}
  constructionUpdate: (data) => Axios.post(`${endpoint}/update`, data),

  //현장목록조회(자신)
  //세션정보로 처리
  constructionListOnSelf: (data) => Axios.get(`${endpoint}/list-on-self`, data),

  //전체현장목록조회
  constructionTotalList: (data) => Axios.post(`${endpoint}/total-list`, data),
};
